import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-left-down', 'CornerLeftDown', [["path",{"d":"M10.027 19V9a4 4 0 0 1 4-4H19M5 14.22 10.027 19l5.028-4.78","key":"svg-0"}]]);